import styles from './ModelActionDialog.module.scss';
import { Trans, useTranslation } from 'react-i18next';
import {
  VdsButton,
  VdsDialog,
  VdsDialogActionFooter,
  VdsDialogBody,
  VdsDialogHeader,
  VdsDialogModal,
} from '@volt/volt-extended-components-react';
import { ReactElement, Ref } from 'react';
import { ModelAction, ModelName } from '@casops/store/api';
import ErrorMessage from '@cas/components/state-management/error-message/ErrorMessage';

interface ModelActionDialogProps {
  modelName: ModelName;
  modelAction: ModelAction;
  elementRef: Ref<HTMLVdsDialogElement>;
  onAction: () => void;
  isError?: boolean;
  isLoading?: boolean;
  itemName?: string;
  danger?: boolean;
}

export default function ModelActionDialog({
  elementRef,
  modelName,
  modelAction,
  onAction,
  isError = false,
  isLoading = false,
  danger = false,
  itemName,
}: ModelActionDialogProps): ReactElement {
  const { t } = useTranslation();

  return (
    <VdsDialog
      ref={elementRef}
      key={`action--${modelAction}--${modelName}`}
      padding="spacing-07"
      backdrop={true}
      width="650px"
      className={styles.removeFootprint}
    >
      <VdsDialogModal>
        <VdsDialogHeader slot="header" show-close-button={false}>
          {t(`Model.${modelAction}.Title`, { modelName })}
        </VdsDialogHeader>

        <VdsDialogBody slot="body" className={styles.body}>
          <p className={styles.content}>
            <Trans
              i18nKey={`Model.${modelAction}.Body`}
              values={{ modelName, itemName }}
              components={{ b: <b />, strong: <strong /> }}
            />
          </p>
          {isError && <ErrorMessage message={t(`Model.${modelAction}.Error`, { modelName })} />}
        </VdsDialogBody>

        <VdsDialogActionFooter slot="footer" class="vds__dialog__footer--end">
          <VdsButton
            variant="tertiary"
            close-dialog=""
            disabled={isLoading}
            style={{ width: 150 }}
            isFullWidth
          >
            {t('Cancel')}
          </VdsButton>
          <VdsButton
            variant="primary"
            onClick={onAction}
            disabled={isLoading}
            danger={danger}
            style={{ width: 150 }}
            isFullWidth
          >
            {t(`Model.${modelAction}.ActionLabel`)}
          </VdsButton>
        </VdsDialogActionFooter>
      </VdsDialogModal>
    </VdsDialog>
  );
}
